import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getApprovalInstances = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/`, body);
        return response.data;
    } catch (error) {
        console.log("getApprovalInstances - error", error)
        return handleApiError(error)
    }
}

export const getApprovalInstancesById = async (approvalInstancesId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/approval-instances/${approvalInstancesId}`);
        return await response.data;
    } catch (error) {
        console.log("getApprovalInstancesById - error", error)
        return handleApiError(error)
    }
}

export const getApprovalInstancesByDocNo = async (docNo) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/docNo`, docNo);
        return await response.data;
    } catch (error) {
        console.log("getApprovalInstancesByDocNo - error", error)
        return handleApiError(error)
    }
}

export const insertApprovalInstances = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertApprovalInstances - error", error)
        return handleApiError(error)
    }
}

export const updateApprovalInstance = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/update`, data);
        return await response.data;
    } catch (error) {
        console.log("updateApprovalInstances - error", error)
        return handleApiError(error)
    }
}

export const updateApprovalInstances = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/bulk-update`, data);
        return await response.data;
    } catch (error) {
        console.log("updateApprovalInstances - error", error)
        return handleApiError(error)
    }
}

export const processApprovalInstance = async (approvalInstancesId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/process/${approvalInstancesId}`, data);
        return await response.data;
    } catch (error) {
        console.log("processApprovalInstance - error", error)
        return handleApiError(error)
    }
}

export const rejectApprovalInstance = async (approvalInstancesId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/reject/${approvalInstancesId}`, data);
        return await response.data;
    } catch (error) {
        console.log("rejectApprovalInstance - error", error)
        return handleApiError(error)
    }
}

export const searchApprovalInstances = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/search`, body);
        return response.data;
    } catch (error) {
        console.log("searchApprovalInstances - error", error)
        return handleApiError(error)
    }
}

export const getApprovalInstancesByDocNos = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/docNos`, data);
        return await response.data;
    } catch (error) {
        console.log("getApprovalInstancesByDocNos - error", error)
        return handleApiError(error)
    }
}

export const getApprovalInstancesByCompanyId = async (companyId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/approval-instances/company/search/${companyId}`, data);
        return await response.data;
    } catch (error) {
        console.log("getApprovalInstancesByCompanyId - error", error)
        return handleApiError(error)
    }
}